<template>
	<input v-model="text" :type="type" :min="min ?? 0" :max="max ?? Number.MAX_VALUE" :step="step ?? 1" :maxlength="maxlength ?? 255" :class="`${full ? 'grow' : ''} rounded border-gray-200 bg-gray-50 dark:bg-slate-900 dark:border-gray-700`" @change="updateValue">
</template>
<script setup lang="ts">
import {ref, type Ref} from 'vue'

const props = defineProps<{
	type:string,
	value:number|string|null,
	min?:number|string,
	max?:number|string,
	step?:number,
	maxlength?:number,
	full?:boolean,
}>()

const text:Ref<number|string|null> = ref(props.value)

const emit = defineEmits([
	'update:value',
])

function updateValue(): void{
	emit('update:value', text.value)
}
</script>
